/* global EventSource, SpeechSynthesisUtterance, window */
import { React, connect, fetchApi } from '@gasbuddy/react';
import { Dimmer, Loader, Segment, Form, Button, Divider } from 'semantic-ui-react';
import { ActionGroups } from '../../roles';
import { Auth, Nav } from '../../components';

class BaseReturnToSender extends React.Component {
  state = {
    type: 'card',
    notify: true,
  }

  componentWillUnmount() {
    if (this.sse) {
      this.sse.close();
      delete this.sse;
    }
  }

  onInputChange = (e) => {
    const { type, lines: oldLines } = this.state;
    const { value } = e.target;
    const lines = (value || '').split('\n').length;
    if (type === 'card' && lines !== oldLines && lines) {
      // eslint-disable-next-line no-console
      try { window.speechSynthesis.speak(new SpeechSynthesisUtterance(lines - 1)); } catch (error) { console.error(error); }
    }
    this.setState({ inputs: value, lines });
  }

  getLabel() {
    const { type } = this.state;
    switch (type) {
      case 'card':
        return 'Track 2 Data (from card reader)';
      case 'address':
        return 'Address starting info + 5 digit postal code';
      default:
        throw new Error('Invalid type');
    }
  }

  getPlaceholder() {
    const { type } = this.state;
    switch (type) {
      case 'card':
        return 'One swipe per line';
      case 'address':
        return 'One pair of address info/postal code per line, separated by comma (do not include commas from address, if any)';
      default:
        throw new Error('Invalid type');
    }
  }

  go = (e) => {
    e.preventDefault();
    const { inputs, type, test, notify, checkSecond } = this.state;
    this.setState({ loading: true, running: true, outputs: '' }, async () => {
      const { body: { id } } = await fetchApi({
        url: '/payments/instruments/return-to-sender',
        body: { inputs, type, test, notify, checkSecond },
      });
      if (this.sse) {
        this.sse.close();
      }
      let outputs = [];
      this.sse = new EventSource(
        `/payments/instruments/return-to-sender/stream/${id}`,
        { withCredentials: true },
      );
      this.sse.onmessage = (sseData) => {
        const data = JSON.parse(sseData.data);
        if (data.length === 0) {
          this.sse.close();
          delete this.sse;
          this.setState({ loading: false, running: false });
        }
        outputs = [...outputs, ...data];
        this.setState({ loading: false, outputs: outputs.join('\n') });
      };
    });
  }

  render() {
    const { inputs, outputs, type, notify, test, loading, running, checkSecond } = this.state;
    return (
      <Auth
        forActions={ActionGroups.Users}
      >
        <Nav>
          <Dimmer.Dimmable as={Segment} dimmed={loading}>
            <Dimmer active={loading}>
              <Loader />
            </Dimmer>
            <div>
              <h1>Record Return-To-Senders</h1>
              <Form onSubmit={this.go}>
                <Form.Group widths="equal">
                  <Form.Dropdown
                    inline
                    label="Identifier Type"
                    defaultValue={type}
                    options={[
                      { text: 'Address portion,Postal Code', value: 'address' },
                      { text: 'Card Swipe', value: 'card' },
                    ]}
                    onChange={(e, { value }) => this.setState({ type: value })}
                  />
                  <Form.Checkbox
                    label="Send emails"
                    defaultChecked={notify}
                    onChange={(d, v) => this.setState({ notify: v.checked })}
                  />
                  <Form.Checkbox
                    label="Dry Run - Do Not Make Any Changes"
                    defaultChecked={test}
                    onChange={(d, v) => this.setState({ test: v.checked })}
                  />
                  <Form.Checkbox
                    label="Check for 2nd Line Problem"
                    defaultChecked={checkSecond}
                    onChange={(d, v) => this.setState({ checkSecond: v.checked })}
                  />
                </Form.Group>
                <Divider />
                <Form.Group widths="equal">
                  <Form.TextArea
                    rows={30}
                    value={inputs}
                    onChange={this.onInputChange}
                    label={this.getLabel()}
                    placeholder={this.getPlaceholder()}
                  />
                  <Form.TextArea
                    rows={30}
                    readOnly
                    value={outputs}
                    label="Results"
                    placeholder="Results will appear here"
                  />
                </Form.Group>
                <Form.Group>
                  <Button loading={loading || running}>Go</Button>
                </Form.Group>
              </Form>
            </div>
          </Dimmer.Dimmable>
        </Nav>
      </Auth>
    );
  }
}

export const ReturnToSender = connect(({ api }) => ({ api }))(BaseReturnToSender);
